﻿import * as moment from 'moment';
import Pikaday from 'pikaday';

import setUpSplitDate from "./features/split-date";

(function () {
    // Making available globally for Umbraco Forms scripts.
    window.moment = moment;
    window.Pikaday = Pikaday;

    document.querySelectorAll('.js-split-date').forEach(rootEl => setUpSplitDate(rootEl));
})();

require("./umbraco-forms/aspnet-validation.min.js");
require("./umbraco-forms/datepicker.init.js");
require("./umbraco-forms/promise-polyfill.min.js");
require("./umbraco-forms/scroll-to-error.js");
require("./umbraco-forms/umbracoforms.js");